import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import moment from "jalali-moment";
import tools from "../../utils/tools";

interface OrderData {
  date: string;
  all: number;
  profit: number;
  worker: number;
}

interface DashboardLineChartProps {
  ordersData: OrderData[];
}

const DashboardLineChart: React.FC<DashboardLineChartProps> = ({
  ordersData,
}) => {
  // Custom tooltip to format prices
  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      return (
        <div
          style={{
            backgroundColor: "white",
            padding: "10px",
            border: "1px solid #ccc",
            borderRadius: "5px",
            direction: "rtl",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          }}
        >
          <p style={{ margin: "0 0 5px 0", fontWeight: "bold" }}>{label}</p>
          {payload.map((entry: any, index: number) => (
            <p key={index} style={{ margin: "5px 0", color: entry.color }}>
              {entry.name}: {tools.formatPrice(entry.value)}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div style={{ width: "100%", height: 400, marginTop: "20px" }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={ordersData}
          margin={{
            top: 20,
            right: 30,
            left: 50,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" angle={-45} textAnchor="end" height={80} />
          <YAxis tickFormatter={(value) => value} />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Line
            type="monotone"
            dataKey="all"
            name="درآمد کل"
            stroke="#ffc658"
            strokeWidth={3}
            activeDot={{ r: 8 }}
          />
          <Line
            type="monotone"
            dataKey="profit"
            name="سهم شرکت"
            stroke="#8884d8"
            strokeWidth={3}
            activeDot={{ r: 8 }}
          />
          <Line
            type="monotone"
            dataKey="worker"
            name="سهم زیباکار"
            stroke="#82ca9d"
            strokeWidth={3}
            activeDot={{ r: 8 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default DashboardLineChart;
